module.exports = __webpack_public_path__ + "img/david.54efbefe.jpeg";